import { render, staticRenderFns } from "./AllocAveValues.vue?vue&type=template&id=6a76fd50&"
import script from "./AllocAveValues.vue?vue&type=script&lang=js&"
export * from "./AllocAveValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports